export enum Status {
    Pending = 'Pending',
    Published = 'Published', 
    Rejected = 'Rejected'
}